import { render } from "./EmptyReturns.vue?vue&type=template&id=51c5fcf5&ts=true"
import script from "./EmptyReturns.vue?vue&type=script&lang=ts"
export * from "./EmptyReturns.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__